<div [ngClass]="showFormGrouped ? 'idp-form-grouped' : ''">
  <div class="idp-checkbox__wrapper">
    <idp-error-tooltip
      *ngIf="(errorState || error) && submitAttempt && showErrorToolTip"
      [arrowPosition]="arrowPosition"
      [errorMessage]="errorMessage"
      [icon]="icon"
      aria-hidden="true"
    ></idp-error-tooltip>
    <span
      *ngIf="focused && submitAttempt && (errorState || error)"
      aria-atomic="true"
      aria-live="polite"
      class="sr-only"
      role="alert"
    >
      {{ errorMessage }}
    </span>
    <label
      (focusin)="setFocused()"
      class="idp-checkbox idp-checkbox__label"
      [attr.data-cy]="'label-' + dataCy"
    >
      <input
        #inputReference
        (blur)="focusOut()"
        (click)="notify($event)"
        (keydown.enter)="notify($event)"
        (focus)="setInputFocus()"
        [attr.aria-label]="errorState || error ? labelTitle : ariaLabel"
        [checked]="checked"
        [disabled]="isDisabled"
        [id]="id"
        [ngClass]="
          submitAttempt && (errorState || error) ? 'idp-checkbox--error' : ''
        "
        class="idp-checkbox"
        data-test-checkbox="true"
        type="checkbox"
        [attr.data-cy]="dataCy"
      />
      <span
        [ngClass]="'idp-checkbox__tick--' + uncheckedBackground"
        class="idp-checkbox__tick"
        [attr.data-cy]="'label-tick-' + dataCy"
      ></span>
      <span class="sr-only">{{ ariaLabel }}</span>
      <span
        [attr.aria-hidden]="ariaHidden"
        [attr.aria-label]="ariaLabel"
        [innerHTML]="labelTitle"
        [ngClass]="getClasses()"
        id="checkbox_label_span_{{ id }}"
        [attr.data-cy]="'label-span-' + dataCy"
      ></span>
      <idp-info-icon
        (iconClicked)="iconClick($event)"
        *ngIf="infoToolTip"
        [labelSrOnly]="labelSrOnly"
        [labelTitle]="labelTitle"
        class="infoIcon"
        [attr.data-cy]="'infoIcon'"
      ></idp-info-icon>
    </label>
    <span *ngIf="description" class="idp-checkbox__description--section">
      <i
        *ngIf="descriptionIcon"
        aria-hidden="true"
        class="idp-checkbox__description--icon"
        [attr.data-cy]="'description--icon-' + dataCy"
      ></i>
      <span
        [innerHTML]="description"
        aria-atomic="true"
        aria-live="polite"
        class="idp-checkbox__description--message"
        [attr.data-cy]="'description--message-' + dataCy"
      ></span>
    </span>
  </div>
</div>
